import {
  MyProjectPermissionResponse,
  PaginatedResponse,
  PaginationQuery,
  ProjectQueryParams,
  ProjectResponse,
} from "@packages/global";
import { httpClient } from "../httpClient";

export class ProjectApi {
  async myProjectPageList(queryData: PaginationQuery<ProjectQueryParams>): Promise<PaginatedResponse<ProjectResponse>> {
    return httpClient.post<PaginatedResponse<ProjectResponse>>("/user/projects/page", queryData);
  }

  async getMyProjectById(id: string): Promise<ProjectResponse> {
    return httpClient.get<ProjectResponse>(`/user/projects/${id}`);
  }

  async listMyProjectPermissions(): Promise<MyProjectPermissionResponse[]> {
    return httpClient.get<MyProjectPermissionResponse[]>("/user/projects/permissions/list");
  }
}

export const projectApi = new ProjectApi();
